<template>
  <div class="contactUs">
    <Header />
    <div class="banner">
      <div class="text">
        <p>携手科云，一同成就你我</p>
        <span>成就客户是我们一直在做的事情，因为专业的技术是我们的底气</span>
      </div>
    </div>
    <div class="content">
      <div class="contactUs-2">
        <div class="contact">联系我们</div>
        <img src="../../../assets/img/about/joinsUs/207.png" class="img" />
        <p>联系电话：13520614030</p>
        <span>通讯地址：广州市天河区建工路南天大厦308</span>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  components: { Header, Footer }
};
</script>
<style lang="scss" scoped>
.contactUs {
  .banner {
    box-sizing: border-box;
    height: 444px;
    padding-top: 140px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 100%;
    background-image: url("../../../assets/img/about/contactUs/215.png");

    .text {
      p {
        height: 62px;
        font-size: 44px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 62px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
      span {
        margin-top: 14px;
        height: 25px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
    }
  }
  .content {
    .contactUs-2 {
      .contact {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 42px;
        color: rgba(41, 43, 58, 1);
        opacity: 1;
        box-sizing: border-box;
        height: 222px;
        padding: 120px 0 60px 0;
      }
      .img {
        width: 1200px;
        height: 580px;
      }
      p {
        margin: 50px 0 15px 0;
        height: 25px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: rgba(41, 43, 58, 1);
        opacity: 1;
      }
      span {
        margin-bottom: 183px;
        display: inline-block;
        height: 25px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: rgba(41, 43, 58, 1);
        opacity: 1;
      }
    }
  }
}
</style>
